import { Link } from "react-router-dom";
import {
  ArrowLeft, Flame, Beef, Wheat, Droplet, Sunrise, Sun, Sunset,
  Apple, Coffee, Check, Target, TrendingDown, Activity,
} from "lucide-react";

const TRAINEE = "NAZAN YURTSEVEN";

const TARGETS = [
  { label: "Kalori", value: "1235", unit: "kcal", icon: Flame },
  { label: "Protein", value: "118", unit: "gr", icon: Beef },
  { label: "Karbonhidrat", value: "105", unit: "gr", icon: Wheat },
  { label: "Yağ", value: "35", unit: "gr", icon: Droplet },
];

const CALORIE_CALC = [
  { label: "Bazal Metabolizma", value: "1336 kcal" },
  { label: "Aktivite Payı", value: "+200 kcal" },
  { label: "Toplam Harcama", value: "1536 kcal" },
  { label: "Açık", value: "-300 kcal", accent: "rose" },
  { label: "Hedef", value: "~1235 kcal", accent: "emerald" },
];

const MEALS = [
  { time: "08:00", title: "Kahvaltı", icon: Sunrise, items: ["2 Tam Yumurta", "2 Yumurta Beyazı", "1 Dilim Tam Buğday Ekmeği", "Domates, Salatalık, Yeşillik"] },
  { time: "11:00", title: "Ara Öğün", icon: Apple, items: ["200 gr Yoğurt", "1 Adet Meyve"] },
  { time: "14:00", title: "Öğle Yemeği", icon: Sun, items: ["150 gr Tavuk Göğüs", "150 gr Pişmiş Pirinç Pilavı", "Büyük Salata"] },
  { time: "17:00", title: "Ara Öğün", icon: Coffee, items: ["100 gr Lor Peyniri"] },
  { time: "20:00", title: "Akşam Yemeği", icon: Sunset, items: ["150 gr Tavuk Göğüs veya Yağsız Et", "110 gr Pişmiş Pirinç Pilavı", "Büyük Porsiyon Sebze"] },
];

const DAILY_GOALS = [
  "Minimum 2.5 litre su tüketimi",
  "Haftada 3-4 gün ağırlık antrenmanı",
  "Haftada 2-3 gün 30 dk yürüyüş veya kardiyo",
  "Her öğünde protein tüketimi",
  "15 günde bir ölçüm ve çevre takibi",
];

const TRACKING = [
  { metric: "Vücut Yağ Yüzdesi", current: "%31.9", target: "%28 ve altı" },
  { metric: "Bel / Kalça Oranı", current: "0.92", target: "0.85 ve altı" },
  { metric: "Gövde Yağı", current: "11.2 kg", target: "Düşüş" },
  { metric: "İskelet Kası", current: "24 kg", target: "Koru / Artır" },
];

export default function NazanNutrition() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="nazan-nutrition">
      {/* TOP NAV */}
      <header className="sticky top-0 z-40 bg-background/90 backdrop-blur-xl border-b border-border">
        <div className="container-x flex items-center justify-between h-14">
          <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary text-sm font-display uppercase tracking-wider">
            <ArrowLeft className="h-4 w-4" /> Anasayfa
          </Link>
          <div className="flex items-center gap-2">
            <img src="/assets/fcs-logo.png" alt="FCS" className="h-9 w-9" />
            <span className="font-display font-black uppercase tracking-wider text-sm">GoodPT</span>
          </div>
          <div className="w-12" />
        </div>
      </header>

      {/* HERO */}
      <section className="relative overflow-hidden border-b border-border">
        <div className="absolute inset-0 grid-bg opacity-50" />
        <div className="absolute -top-20 -right-20 h-[280px] w-[280px] rounded-full bg-rose-500/15 blur-3xl" />
        <div className="absolute -bottom-20 -left-20 h-[280px] w-[280px] rounded-full bg-emerald-500/15 blur-3xl" />

        <div className="container-x relative py-8 md:py-12 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-rose-500/15 ring-1 ring-rose-500/30 mb-4">
            <span className="h-1.5 w-1.5 rounded-full bg-rose-400 pulse-soft" />
            <span className="text-[10px] font-display font-bold uppercase tracking-[0.25em] text-rose-300">Kişisel Beslenme · Recomp</span>
          </div>
          <div className="text-xs font-display uppercase tracking-[0.3em] text-muted-foreground mb-2">Hazırlanan Sporcu</div>
          <h1 className="font-brand uppercase leading-[0.9]" style={{ fontSize: "clamp(2.25rem, 9vw, 4.5rem)" }}>
            {TRAINEE}
          </h1>
          <p className="mt-4 max-w-md mx-auto text-sm md:text-base text-muted-foreground leading-relaxed">
            Yağ kaybederken kas kütlesini korumak ve artırmak.
            <span className="block mt-1 text-primary font-display font-bold uppercase tracking-widest text-xs">Recomposition</span>
          </p>
        </div>
      </section>

      {/* DAILY TARGETS */}
      <section className="py-6 border-b border-border bg-[hsl(218_55%_5%)]">
        <div className="container-x">
          <div className="text-center mb-4">
            <div className="eyebrow justify-center">Günlük Hedef</div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {TARGETS.map((t) => (
              <div key={t.label} className="card-elev p-4 text-center">
                <div className="h-9 w-9 rounded-md bg-emerald-500/15 ring-1 ring-emerald-500/30 flex items-center justify-center text-emerald-300 mx-auto mb-2">
                  <t.icon className="h-4 w-4" />
                </div>
                <div className="font-display text-2xl font-black leading-none">
                  {t.value}
                  <span className="text-xs text-muted-foreground ml-1">{t.unit}</span>
                </div>
                <div className="mt-1 text-[10px] font-display uppercase tracking-[0.2em] text-muted-foreground">{t.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CALORIE BREAKDOWN */}
      <section className="py-10">
        <div className="container-x max-w-2xl mx-auto">
          <div className="text-center mb-5">
            <div className="eyebrow justify-center">Kalori Hesabı</div>
          </div>
          <div className="card-elev p-5 space-y-2.5">
            {CALORIE_CALC.map((c, i) => {
              const accent = c.accent === "rose" ? "text-rose-400" : c.accent === "emerald" ? "text-emerald-400" : "";
              const isHighlight = i === CALORIE_CALC.length - 1;
              return (
                <div
                  key={c.label}
                  className={`flex items-center justify-between py-2 ${i !== CALORIE_CALC.length - 1 ? "border-b border-border/60" : "pt-3 border-t-2 border-primary/40"}`}
                >
                  <span className={`text-sm ${isHighlight ? "font-display font-black uppercase tracking-wider" : "text-muted-foreground"}`}>{c.label}</span>
                  <span className={`font-display font-black ${isHighlight ? "text-xl" : "text-base"} ${accent || "text-foreground"}`}>{c.value}</span>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* MEALS */}
      <section className="pb-10 border-b border-border">
        <div className="container-x max-w-2xl mx-auto">
          <div className="text-center mb-6">
            <div className="eyebrow justify-center mb-1">Öğün Planı</div>
            <h2 className="heading-md">5 Öğün</h2>
          </div>

          <div className="space-y-3">
            {MEALS.map((meal, i) => (
              <article key={i} className="card-elev p-4 md:p-5" data-testid={`nazan-meal-${i}`}>
                <header className="flex items-center gap-3 mb-3 pb-3 border-b border-border">
                  <div className="h-10 w-10 rounded-md bg-primary/10 ring-1 ring-primary/30 flex items-center justify-center text-primary shrink-0">
                    <meal.icon className="h-4 w-4" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-[10px] font-display font-bold uppercase tracking-[0.22em] text-muted-foreground">{meal.time}</div>
                    <div className="font-display text-lg font-black uppercase tracking-tight">{meal.title}</div>
                  </div>
                </header>
                <ul className="space-y-1.5">
                  {meal.items.map((it, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm">
                      <Check className="h-4 w-4 text-emerald-400 mt-0.5 shrink-0" />
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* DAILY TOTAL */}
      <section className="py-10 border-b border-border bg-gradient-to-br from-emerald-500/10 via-background to-background">
        <div className="container-x max-w-3xl mx-auto">
          <div className="text-center mb-5">
            <div className="eyebrow justify-center">Günlük Toplam</div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            <Stat label="Protein" value="~118 gr" color="text-emerald-400" />
            <Stat label="Karbonhidrat" value="~105 gr" color="text-amber-300" />
            <Stat label="Yağ" value="~35 gr" color="text-primary" />
            <Stat label="Kalori" value="~1235 kcal" color="text-rose-400" />
          </div>
        </div>
      </section>

      {/* DAILY GOALS */}
      <section className="py-10">
        <div className="container-x max-w-2xl mx-auto">
          <div className="text-center mb-5">
            <div className="eyebrow justify-center mb-1">Günlük Hedefler</div>
            <h2 className="heading-md">Disiplin Kuralları</h2>
          </div>
          <div className="space-y-2.5">
            {DAILY_GOALS.map((g, i) => (
              <div key={i} className="card-elev p-3.5 flex items-start gap-3">
                <Target className="h-4 w-4 text-primary mt-1 shrink-0" />
                <span className="text-sm">{g}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TRACKING METRICS */}
      <section className="py-10 border-y border-border bg-[hsl(218_55%_5%)]">
        <div className="container-x max-w-3xl mx-auto">
          <div className="text-center mb-6">
            <div className="eyebrow justify-center mb-1">Hedef Takip Kriterleri</div>
            <h2 className="heading-md">15 Günlük Ölçüm</h2>
          </div>
          <div className="grid sm:grid-cols-2 gap-3">
            {TRACKING.map((t, i) => (
              <div key={i} className="card-elev p-4" data-testid={`tracking-${i}`}>
                <div className="text-[10px] font-display font-bold uppercase tracking-[0.22em] text-muted-foreground mb-2">{t.metric}</div>
                <div className="flex items-center gap-3">
                  <div className="flex-1">
                    <div className="text-[9px] font-display uppercase tracking-widest text-muted-foreground">Şu an</div>
                    <div className="font-display text-xl font-black text-rose-400">{t.current}</div>
                  </div>
                  <TrendingDown className="h-5 w-5 text-primary shrink-0" />
                  <div className="flex-1 text-right">
                    <div className="text-[9px] font-display uppercase tracking-widest text-muted-foreground">Hedef</div>
                    <div className="font-display text-xl font-black text-emerald-400">{t.target}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CLOSING TIPS */}
      <section className="py-10">
        <div className="container-x max-w-2xl mx-auto">
          <div className="card-elev p-5 md:p-6">
            <div className="eyebrow mb-3">Hatırlatma</div>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-start gap-2"><Activity className="h-4 w-4 text-primary mt-0.5 shrink-0" /><span>Beslenme planı zorlanırsa antrenörüne danış — porsiyon ayarlanabilir.</span></li>
              <li className="flex items-start gap-2"><Activity className="h-4 w-4 text-primary mt-0.5 shrink-0" /><span>Antrenman günü 1 saat önce protein + karbonhidrat al.</span></li>
              <li className="flex items-start gap-2"><Activity className="h-4 w-4 text-primary mt-0.5 shrink-0" /><span>Uyku 7-9 saat — recomp sürecinin kritik bileşeni.</span></li>
            </ul>
          </div>
        </div>
      </section>

      <footer className="border-t border-border py-6 text-center text-xs text-muted-foreground">
        <img src="/assets/fcs-logo.png" alt="FCS" className="h-10 w-10 mx-auto mb-2" />
        Focus Spor Kulübü · GoodPT Kişisel Beslenme
      </footer>
    </div>
  );
}

function Stat({ label, value, color }) {
  return (
    <div className="card-elev p-4 text-center">
      <div className={`font-display text-xl md:text-2xl font-black ${color} leading-none`}>{value}</div>
      <div className="mt-2 text-[10px] font-display uppercase tracking-[0.22em] text-muted-foreground">{label}</div>
    </div>
  );
}
